import React from 'react'
import { NavLink } from 'react-router-dom'
// import About from './About'
import Contact from './Contact'
import Footer from './Footer'
import Services from './Services'

const Home = () => {
    return (
        <div>
            <section id='home' >
                <div className='container '>
                    <div className='row justify-content-center align-items-center d-flex '>
                        <div className='col-md-8 mt-5'>
                            <h1 className='display-4 fw-bolder mb-4 text-center '>
                               LET US BRIGHTEN YOUR <br /> SMILE
                            </h1>
                            <p className='lead text-center text-black fw-bold fs-4 mb-5 '>
                                <i><b>W</b>elcome to the Dentalcare</i></p>
                            <div className='buttons d-flex justify-content-center'>
                                <NavLink to="/contact" className='btn radi fw-bold px-4 py-2 me-4 rounded'>Make Appointment</NavLink>
                                <NavLink to='/service' className='btn radi px-4 fw-bold  rounded'>Our Service</NavLink>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <hr />  
            <Services></Services>
            <Contact></Contact>
            <Footer />
        </div>
    )
}

export default Home